import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldAlert, ArrowRight, Bell, Zap, Users, Siren } from "lucide-react";
import { IMAGES } from "../../data";

const FEATURES = [
  { icon: Bell, text: "Alarma sonora disuasoria ante una situación de peligro" },
  { icon: Zap, text: "Luz estroboscópica de emergencia para alertar y disuadir" },
  { icon: Users, text: "Aviso automático a tus contactos de confianza con tu ubicación" },
  { icon: Siren, text: "Conexión con los servicios de emergencia en tiempo real" },
];

export default function Sistemas() {
  return (
    <section id="sistemas" className="py-20 lg:py-28 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative order-2 lg:order-1"
        >
          <div className="absolute -bottom-3 -right-3 h-full w-full border-2 border-espana-gold" />
          <img
            src={IMAGES.auxilia}
            alt="Persona usando la app de protección personal AUXILIA E² por la noche"
            className="relative w-full h-[360px] object-cover"
          />
        </motion.div>

        <div className="order-1 lg:order-2">
          <div className="inline-flex items-center gap-2 h-12 w-12 justify-center bg-espana-red text-white mb-6">
            <ShieldAlert size={26} />
          </div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-espana-red mb-3">
            Sistemas E²
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight">
            AUXILIA E²
          </h2>
          <p className="mt-5 text-lg text-gray-600 leading-relaxed">
            AUXILIA E² es un sistema (app) de <strong>protección personal</strong>.
            Ante una situación de peligro, activa una alarma sonora y una luz
            estroboscópica, y avisa automáticamente a tus contactos de confianza y a
            los servicios de emergencia con tu ubicación.
          </p>
          <ul className="mt-6 space-y-3 text-gray-700">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <li key={f.text} className="flex items-start gap-3">
                  <Icon size={18} className="text-espana-red mt-0.5 shrink-0" strokeWidth={2} />
                  <span>{f.text}</span>
                </li>
              );
            })}
          </ul>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/auxilia"
              data-testid="sistemas-ver-mas"
              className="inline-flex items-center gap-2 bg-espana-red hover:bg-espana-reddark text-white font-bold px-6 py-3.5 rounded-sm transition-colors"
            >
              Conocer AUXILIA E² <ArrowRight size={18} />
            </Link>
            <button
              data-testid="sistemas-cta"
              onClick={() => document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center gap-2 border border-gray-300 hover:bg-white font-bold px-6 py-3.5 rounded-sm transition-colors"
            >
              Solicitar información <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
